export const roles = ['user', 'admin', 'superadmin', 'pharmacy'];

export const userTypeTranslations = {
  individual: 'Fizicko lice',
  company: 'Pravno lice',
};
//TODO: Change it latter for statuses
export const userStatusTranslations = {
  active: 'Aktivan',
  suspended: 'Suspendovan',
  archived: 'Arhiviran',
  pending_verification: 'Ceka verifikaciju',
  pre_registration: 'Registracija nedovrsena',
  rejected: 'Odbijen',
};

export const userRoleTranslations = {
  user: 'Korisnik',
  admin: 'Admin',
  superadmin: 'Super admin',
  pharmacy: 'Apoteka',
};

export const userPickupMethodOptions = [
  { value: 'APO', label: 'APO' },
  { value: 'APO/PTT', label: 'APO/PTT' },
  { value: 'APO/V', label: 'APO/V' },
  { value: 'APO/AKS/BEX', label: 'APO/AKS/BEX' },
  { value: 'ZA KLINIKU', label: 'ZA KLINIKU' },
  { value: 'L\u017D', label: 'L\u017D' },
  { value: 'NEAKTIVAN', label: 'NEAKTIVAN' },
  { value: 'POTENT', label: 'POTENT' },
  { value: 'PTT', label: 'PTT' },
  { value: 'R', label: 'R' },
  { value: 'R/APO', label: 'R/APO' },
  { value: 'R/APO/V', label: 'R/APO/V' },
  { value: 'R/K', label: 'R/K' },
  { value: 'R/PTT', label: 'R/PTT' },
  { value: 'R/V', label: 'R/V' },
  { value: 'V', label: 'V' },
];
